export default __webpack_public_path__ + "static/media/Dashboard.1597228b.jpg";